<template lang="pug">
    .wrapper
        nav.nav
            div
            div
            button.button__action(
                @click="toggleCreateMarketModal"
                to="/products/create"
            ) Create New Market
        LibraryGrid
            .view-explanation
                h1 Markets
                p Markets are comprised of two parts: a country and a language. Creating new markets will allow you to create new local records for Action Cards, Media, Products, and Product Groups.
            button.box(
                @click="toggleCreateMarketModal"
                v-if="!getMarkets.length"
            ) Create a New Market
            .market-list
                .market(
                    :key="`${market._id}`"
                    v-for="market in getMarkets"
                    v-if="getMarkets.length"
                    :to="`/markets/${market._id}`"
                )
                    .market-information
                        .flag
                            img(
                                :src="getFlagUrl(market)"
                            )
                        .market-details
                            h3 {{market.title}}
                            .market-minor
                                p
                                    strong Locale
                                    | {{market.locale}}
                                p
                                    strong Country:
                                    | {{market.country}}
                                p
                                    strong Language:
                                    | {{market.primaryLanguage}}
                    .buttons
                        router-link(
                            :to="`/markets/${market._id}`"
                        ).button__action Edit
</template>
<script>
import LibraryGrid from '../general/LibraryGrid';
import Services from '../../services/Services';
import store from '../../store';
export default {
  name: 'MarketLibrary',
  components: {
    LibraryGrid
  },
  computed: {
    // getProductGroups() {
    //   return store.getters.getAllProductGroups;
    // },
    getMarkets() {
      return store.getters.getMarkets;
    }
  },
  data() {
      return {
          getFlagUrl: Services.getFlagUrl,
      }
  },
  mounted() {
    // Services.getProductGroups();
    Services.getMarkets();
    Services.setActiveMarket(null);
  },
  methods: {
    toggleCreateMarketModal() {
      return store.commit('showCreateMarketModal', true);
    }
  }
};
</script>
<style lang="scss" scoped>
.market-list {
    display: flex;
    flex-direction: column;
    padding: 1rem 1.6rem;
    width: 100%;
}
.market {
    background: #FFF;
    border-bottom: 1px solid #CCC;
    padding: 1rem 0.625rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .market-information {
        height: 100%;
        align-items: center;
        display: flex;
        width: 40%;

        .flag {
            margin-right: 1rem;
        }

        .flag img {
            box-shadow: 0 0 2px rgba(0,0,0,0.4);
            padding: 0 10px;
        }

        .market-details {
            display: flex;
            flex-direction: column;
            width: 100%;

            h3 {
                margin-bottom: 0;
                margin-top: 0;
            }

            .market-minor

                p {
                    margin: 0;
                    line-height: 1.4rem;
                    display: inline-block;
                    margin-right: 10px;

                    strong {
                        font-weight: bold !important;
                        margin-right: 3px;
                    }
                }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/views/MarketLibrary.vue